// @ts-nocheck
import React from 'react';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import DestinatariosReduced from "../DestinatariosReduced";
import Tooltip from '@mui/material/Tooltip';
import InternosReduced from "./InternosReduced";
import { ModalGeneral } from "../../Componentes/ModalGeneral";
import { Visibility } from '@mui/icons-material';
import { pad } from 'crypto-js';

export default function AreaInternoItem(props) {
    const { internos, nombre, areaPath, handleOpenDetails } = props;

    return (
        <>
            <ListItem
                sx={{
                    borderRadius: '30px',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f0f0f0',
                    },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "20px"
                }}
                onClick={() => handleOpenDetails(areaPath)}
            >
                <div>
                    <Typography
                        sx={{
                            display: "inline-block",
                            maxWidth: { xs: "150px", sm: "200px", md: "300px" },
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            verticalAlign: "middle",
                        }}
                        component="span"
                        variant="h5"
                        color="textPrimary">
                        {nombre}
                    </Typography>
                    <Typography component="span" variant="body1" color="textPrimary">
                        <InternosReduced internos={internos} />
                    </Typography>

                </div>
                <Tooltip title="Ver Integrantes y Alias Asociados">
                    <IconButton
                        onClick={() => handleOpenDetails(areaPath)}
                        size="large"

                    >
                        <Visibility color="primary" />
                    </IconButton>
                </Tooltip>
            </ListItem >
        </>
    );
}